import React from 'react';
import { Link } from 'react-router-dom';

export default function PremiumModal({ onClose, reason }) {
  const messages = {
    save_limit: {
      icon: '📍',
      title: 'Save limit reached',
      desc: 'Free accounts can save up to 3 chargers. Upgrade to Premium for unlimited saves, instant alerts, and route planning.',
    },
    route_limit: {
      icon: '🧭',
      title: 'Daily route limit reached',
      desc: 'Free accounts get 1 route plan per day. Upgrade to Premium for unlimited route planning.',
    },
    default: {
      icon: '⭐',
      title: 'Premium feature',
      desc: 'Upgrade to ChargeSure Premium for unlimited saves, instant alerts, route planning and more.',
    },
  };

  const msg = messages[reason] || messages.default;

  return (
    <div style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,0.4)', backdropFilter:'blur(8px)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{ background:'var(--slate)', borderRadius:20, padding:28, maxWidth:380, width:'100%', border:'1px solid var(--teal-mid)', boxShadow:'0 20px 60px rgba(0,0,0,0.15)' }}>
        <div style={{ textAlign:'center', marginBottom:20 }}>
          <div style={{ width:64, height:64, borderRadius:18, background:'linear-gradient(135deg,#00A878,#2563EB)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:30, margin:'0 auto 16px' }}>{msg.icon}</div>
          <h3 style={{ fontSize:20, fontWeight:700, marginBottom:8, color:'var(--text-1)' }}>{msg.title}</h3>
          <p style={{ fontSize:14, color:'var(--text-2)', lineHeight:1.6 }}>{msg.desc}</p>
        </div>
        <div style={{ background:'var(--navy)', borderRadius:12, padding:'12px 16px', marginBottom:20 }}>
          {['📍 Unlimited saved chargers','🔔 Instant status alerts','🧭 Unlimited route planning','🚫 Ad-free experience','📊 30-day reliability history'].map(f => (
            <div key={f} style={{ fontSize:13, color:'var(--text-2)', padding:'5px 0', display:'flex', gap:8 }}>
              <span style={{ color:'var(--teal)' }}>✓</span> {f}
            </div>
          ))}
        </div>
        <Link to="/premium" onClick={onClose} style={{ display:'block', textAlign:'center', padding:'13px 0', borderRadius:12, background:'var(--teal)', color:'white', fontWeight:700, fontSize:15, textDecoration:'none', marginBottom:10 }}>
          Upgrade to Premium — €3.99/mo
        </Link>
        <button onClick={onClose} style={{ width:'100%', padding:'10px 0', borderRadius:12, border:'1px solid var(--border-2)', background:'none', color:'var(--text-3)', fontSize:14, cursor:'pointer', marginBottom:10 }}>
          Maybe later
        </button>
        <p style={{ textAlign:'center', fontSize:12, color:'var(--text-3)', margin:0 }}>Or submit 10 reports to unlock Premium free</p>
      </div>
    </div>
  );
}
